import { render, staticRenderFns } from "./List-doenca.vue?vue&type=template&id=537ee020&"
import script from "./List-doenca.vue?vue&type=script&lang=js&"
export * from "./List-doenca.vue?vue&type=script&lang=js&"
import style0 from "./List-doenca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports